// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3Apwr","gradient":"Button_gradient__DFikJ","secondary":"Button_secondary__t3CmO"};